const functionalMap = {
  gridTitle: "Функциональная карта GAM",
  lockedNotice: "Заблокированная структура: 3 уровня × 5 функций. Нельзя добавлять/удалять ячейки.",
  levelStrategy: "Стратегия",
  levelManagement: "Управление",
  levelOperations: "Операции",
  funcSales: "Продажи",
  funcDelivery: "Реализация",
  funcFinance: "Финансы",
  funcHr: "HR",
  funcTechnology: "Технологии",
  statusActive: "Активный",
  statusPartial: "Частичный",
  statusPlanned: "Запланирован",
  owner: "Ответственный",
  tools: "Инструменты",
  description: "Описание",
  clickToEdit: "Нажмите для редактирования",
  saving: "Сохранение...",
  saved: "Сохранено",
  legend: "Легенда",
  noOwner: "Не назначен",
  realtimeConnected: "Подключено",
  realtimeConnecting: "Подключение...",
  realtimeDisconnected: "Отключено",
  items: "Элементы",
  addItem: "Добавить",
  itemPlaceholder: "Новый элемент...",
  noItems: "Нет элементов",
  notes: "Заметки",
  kpis: "Показатели",
  addKpi: "Добавить KPI",
  noKpis: "Нет показателей",
  links: "Ссылки",
  addLink: "Добавить ссылку",
  noLinks: "Нет ссылок",
  progress: "Прогресс",
  details: "Детали",
  lastUpdated: "Обновлено",
  stale: "Устарело",
  cells: "Ячейки",
  labelPlaceholder: "Название",
  valuePlaceholder: "Значение",
  targetPlaceholder: "Цель",
  daysAgo: "дней назад",
  filterAll: "Все",
} as const;
export default functionalMap;
